//làm tròn số
export const formatNumber = (value,digit=1) =>{
    
    switch(digit){
        case 1:
          return  Math.round(value * 10) / 10;
         case 2:
           return  Math.round(value * 100) / 100;
        case 3:
            return  Math.round(value * 1000) / 1000;
         default:
           return value;
     }
}